import React, { useState } from 'react';
import {
  Container,
  Box,
  Typography,
  Grid2,
  Paper,
  Button,
  Fade,
  Slide,
  Divider,
  Stack,
  Chip,
} from '@mui/material';
import {
  Assessment,
  ArrowForward,
} from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { admin_data, organization_data, primaryFeatures, 
  student_data_, 
  tutor_data_, 
  video_data_} from './Helper';
import Footer from './Footer';
import SlideImage from './SlideImage';
import VideoSection from './VideoSection';
import ImageContainer from './ImageContainer';
import Purpose from './Purpose';
import ElegantImageTextSection from './ElegantImageTextSection';
import ImageContent from './ImageContent';


const Hero = () => (
  <Box sx={{ textAlign: 'center', py: { xs: 8, md: 10 }, position: 'relative' }}>
    <Assessment
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: { xs: 300, md: 400 },
        color: (t) => (t.palette.mode === 'dark' ? 'grey.800' : 'grey.200'),
        zIndex: -1,
        opacity: 0.8,
      }}
    />
    <Fade in timeout={1000}>
      <Typography variant="h2" fontWeight={800} color="text.primary">
        Deliver educational services effortlessly
      </Typography>
    </Fade>
    <Fade in timeout={1200}>
      <Typography variant="h5" color="text.secondary" sx={{ mt: 2, mb: 4, maxWidth: '600px', mx: 'auto' }}>
        Easy monitoring, powerful analytics, data logs within seconds.
      </Typography>
    </Fade>
    <Fade in timeout={1400}>
      <Button
        variant="contained"
        size="large"
        onClick={() => {window.location.href = '/register'}}
        endIcon={<ArrowForward />}
        sx={{
          borderRadius: '999px',
          px: 5,
          py: 1.5,
          fontWeight: 600,
          boxShadow: 'none',
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px) scale(1.03)',
            boxShadow: 'none',
          },
        }}
      >
        Get Started
      </Button>
    </Fade>
  </Box>
);

const HomePage = () => {
  const [mode, setCurrentMode] = useState('light');
  const navigate = useNavigate();
  const toggleTheme = () => {
    setCurrentMode((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  return (
    <Fade in timeout={500}>
      <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
        <Container maxWidth={"lg"} sx={{ py: 4, position: 'relative', p: 0 }}>

          {/* === NEW: Top Right Authentication & Utility Stack === */}
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ position: 'absolute', top: 24, right: 24, zIndex: 10 }}
          >
            <Button
              color="inherit"
              onClick={() => navigate('/login')}
              sx={{ fontWeight: 600, display: { xs: 'none', sm: 'inline-flex' } }}
            >
              Login
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => navigate('/register')}
              sx={{ fontWeight: 600, display: { xs: 'none', sm: 'inline-flex' } }}
            >
              Register
            </Button>
            
          </Stack>

          <Hero />


          <Divider sx={{ my: 8, fontSize: '1rem', fontWeight: 600 }}>
             <Chip color='info' label="Powerfull visualization" />
          </Divider>
          
          <Container>
            <ImageContainer item={admin_data} />
          </Container>


          <Container>
            <ElegantImageTextSection
              onButtonClick={(e) => console.log(e)}
              
            />
          </Container>


          <Divider sx={{ my: 2, fontSize: '1rem', fontWeight: 600 }}>
          </Divider>

          <Container>
              <SlideImage payload={tutor_data_} />
              <SlideImage payload={student_data_} />
          </Container>

          <Divider sx={{ my: 8, fontSize: '1rem', fontWeight: 600 }}> 
             <Chip color='info' label="Get a sneak peek" />
          </Divider>


          <Container>
            <VideoSection payload={video_data_} />
          </Container>

          <Divider sx={{ my: 8, fontSize: '1rem', fontWeight: 600 }}> 
             <Chip color='info' label="How we organize" />
          </Divider>

          <Container>
            <ImageContent item={organization_data} />
          </Container>

          <Divider sx={{ my: 8, fontSize: '1rem', fontWeight: 600 }}> 
             <Chip color='info' label="To sum it up" />
          </Divider>

          <Grid2 container spacing={4} sx={{ mt: { xs: 4, md: 8 } }}>
            {primaryFeatures.map((item, index) => (
              <Grid2 item size={{xs:12, md: 6}} key={item.title}>
                <Slide direction="up" in timeout={500 + index * 200}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      borderColor: (t) => t.palette.mode === 'dark' ? 'grey.800' : 'grey.200',
                      borderRadius: 4,
                      transition: 'border-color 0.3s, box-shadow 0.3s',
                      '&:hover': {
                        borderColor: `primary.main`                      },
                    }}
                  >
                    <Box sx={{ color: `${item.color}.main` }}>{item.icon}</Box>
                    <Typography variant="h6" fontWeight={700}>
                      {item.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {item.description}
                    </Typography>
                  </Paper>
                </Slide>
              </Grid2>
            ))}
          </Grid2>      

          {/* Divider and section for additional features */}
          <Divider sx={{ my: 3, fontSize: '1rem', fontWeight: 600 }}>
             <Chip color='info' label="Who is this for ?" />
          </Divider>

          <Container>
            <Purpose />
          </Container>
    
        </Container>
        <Footer />
      </Box>

    </Fade>
  );
};

export default HomePage;